import { createReducer } from '@reduxjs/toolkit';
import get from 'lodash/get';
import * as actions from 'store/getCare/liveCare/actions';
import { setFetchingState, setFetchingFailState } from 'store/setLocalStore';
import { normalizedFacilities } from './mappers';

export interface LiveCareState {
  locationSearchSuccess: boolean;
  isFetching: boolean;
  allFacilities?: ReturnType<typeof normalizedFacilities>;
  error?: string;
  searchGeocode?: any;
  searchLocation?: any;
}

const liveCareInitialState: LiveCareState = {
  isFetching: false,
  error: undefined,
  locationSearchSuccess: false,
  allFacilities: undefined,
  searchGeocode: undefined,
  searchLocation: undefined
};

const liveCareReducer = createReducer(liveCareInitialState, {
  [actions.LIVE_CARE_LOCATION_TEXT]: (state, action) => {
    state.searchLocation = action.payload;
    state.allFacilities = undefined;
  },
  [actions.GET_FACILITIES]: setFetchingState,
  [actions.GET_FACILITIES_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.locationSearchSuccess = true;
    state.error = undefined;
    state.allFacilities = normalizedFacilities(get(action, 'payload.data', []));
  },
  [actions.GET_FACILITIES_FAIL]: setFetchingFailState,
  [actions.GET_GEOCODE]: (state, action) => {
    state.error = undefined;
    state.isFetching = true;
    state.allFacilities = undefined;
    state.searchLocation = action.payload.request.params.address;
  },
  [actions.GET_GEOCODE_SUCCESS]: (state, action) => {
    state.searchGeocode = get(action, 'payload.data', {});
    state.locationSearchSuccess = true;
    state.isFetching = false;
    state.error = undefined;
  },
  [actions.GET_GEOCODE_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  }
});

export default liveCareReducer;
